import { apiGetBlob, USE_MOCK_API } from '../api/httpClient'
import type { Document } from '../api/types'

export async function fetchDocumentFile(document: Document): Promise<Blob> {
  if (USE_MOCK_API) throw new Error('File preview requires the connected server')
  const key = document.file_url.split('/').map(encodeURIComponent).join('/')
  return apiGetBlob(`/files/${key}`)
}

export async function downloadDocumentFile(document: Document): Promise<void> {
  const blob = await fetchDocumentFile(document)
  const url = URL.createObjectURL(blob)
  const link = window.document.createElement('a')
  link.href = url
  link.download = document.file_url.split('/').pop() || 'document'
  window.document.body.append(link)
  link.click()
  link.remove()
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000)
}
